import { Component, OnInit, Inject, ChangeDetectorRef, Input } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { EditarAseguradoraComponent } from "../editar-aseguradora/editar-aseguradora.component";
import { ImageCroppedEvent } from "ngx-image-cropper";
// Service
import { GeneralService } from "src/app/core/services/general.service";

@Component({
  selector: "edit-image-modal",
  templateUrl: "./edit-image-modal.component.html",
})
export class EditImageModal implements OnInit {
  customFolder: string = "firma_aseguradora";
  loadingFile = false;
  file;
  fileId;
  croppedImage: any = "";
  imageChangedEvent: any = "";

  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
    // console.log(event);
  }
  imageLoaded() {
    // console.log('loaded');
    // show cropper
  }
  cropperReady() {
    // console.log('ready');
    // cropper ready
  }
  loadImageFailed() {
    // console.log('failed');
    // show message
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
    this.file = event.target.files[0].name;
  }

  constructor(public dialogRef: MatDialogRef<EditarAseguradoraComponent>, @Inject(MAT_DIALOG_DATA) public data, private cdr: ChangeDetectorRef, private generalService: GeneralService) {
    if (data && data.customFolder) {
      this.customFolder = data.customFolder;
    }
  }

  ngOnInit(): void {}

  onNoClick(result): void {
    this.dialogRef.close(result);
  }

  uploadFile() {
    this.loadingFile = true;
    const formdata = new FormData();

    // Extract base64 data and mime type
    const matches = this.croppedImage.match(/^data:(.+);base64,(.+)$/);
    if (!matches) {
      // handle error
      this.loadingFile = false;
      return;
    }
    const mimeType = matches[1];
    const base64Data = matches[2];

    // Convert base64 to byte array
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // Create Blob
    const blob = new Blob([byteArray], { type: mimeType });

    formdata.append("file", blob, this.file);
    formdata.append("folder", this.customFolder);
    this.generalService.uploadFile(formdata).subscribe(
      (res: any) => {
        this.fileId = res.fileId;
        this.loadingFile = false;
        this.cdr.markForCheck();
        this.onNoClick({ fileId: this.fileId, fileName: this.file });
      },
      (err) => {
        // console.log(err);
        this.loadingFile = false;
        this.cdr.markForCheck();
      }
    );
  }
}
